import { ReactElement, useEffect } from "react";
import { useAppDispatch, useAppSelector } from "./app/hooks";
import { CommonState } from "./app/interfaces/common";
import { screens } from "./app/data/app";
import { getGameStatus } from "./app/slices/appSlice";
import App from "./App";

export const AppWrap = ():ReactElement => {
  const {screen} = useAppSelector((state: CommonState) => state.app)
  const dispatch = useAppDispatch()

  let didInit: boolean
  useEffect(() => {
    if (!didInit) {
      didInit = true
      dispatch(getGameStatus({ttl: 3}))
    }
  }, [])

  return (() => {
    switch (screen) {
      case screens.EMPTY:
        return <></>
      default:
        return <App/>
    }
  })()
}